(function () {
	const els = document.getElementsByClassName(`icon-animated`);
	if (els.length === 0) {
		return;
	}

	const options = {
		threshold: 0.5,
	};

	let observer = null;

	const callback = (entries) => {
		for (const entry of entries) {
			entry.target.classList.toggle(`is-animated`, entry.isIntersecting);
		}
	};

	observer = new IntersectionObserver(callback, options);

	for (const el of els) {
		observer.observe(el);
	}
})();
